import { Children, cloneElement } from "react";
import { Props, Root } from "./Accordion.Parts";
import { AccordionItem } from "./accordion-item/AccordionItem";
import { AccordionItemSkeleton } from "./accordion-item/AccordionItem.Skeleton";

export const Accordion = ({ collapsible = true, ...props }: Props) => {
  const items = Children.map(props.children, (child, i) => {
    if (child.type !== AccordionItem && child.type !== AccordionItemSkeleton)
      throw new Error("Children should be of type `AccordionItem`");
    return cloneElement(child, {
      key: i,
      value: child.props.value ?? `item-${i + 1}`,
      disabled: props.disabled,
      index: i,
    });
  });

  if (props.type === "multiple") {
    // Here TS knows props is MultipleAccordion
    const {
      type, // "multiple"
      defaultValue, // string[]
      value, // string[]
      onValueChange, // (val: string[]) => void
      children,
      width,
      ...restProps
    } = props;

    return (
      <Root
        type="multiple"
        defaultValue={defaultValue}
        value={value}
        onValueChange={onValueChange}
        $width={width}
        {...restProps}
      >
        {items}
      </Root>
    );
  }

  // Here TS knows props is SingleAccordion
  const {
    type, // "single"
    defaultValue, // string
    value, // string
    onValueChange, // (val: string) => void
    children,
    width,
    ...restProps
  } = props;

  return (
    <Root
      type="single"
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
      collapsible={collapsible}
      $width={width}
      {...restProps}
    >
      {items}
    </Root>
  );
};
